import { FC, useState, useCallback } from 'react'
import dynamic from 'next/dynamic'

const ChatScroll = dynamic(() => import('./chat-scroll/chat-scroll'), { ssr: false })
import ChatBottom from './chat-bottom/chat-bottom'
import ButtonFAQ from '../button-faq/button-faq'
import Auth from 'store/auth'
import useSurvey from 'store/common/useSurvey'

import { surveyStatus } from './survey/data'
import { IChatMessage } from 'constants/types/webinar.types'

import styles from './webinar-chat.module.scss'

interface IWebinarChat {
  isReminderAvailable: boolean
}

const WebinarChatNew: FC<IWebinarChat> = ({ isReminderAvailable }) => {
  const { isFilledUser, isSponsor } = Auth.useAuth()
  const { status } = useSurvey()
  const [msgToReply, setMsgToReply] = useState(null as IChatMessage | null)

  const handleCancelReply = () => setMsgToReply(null)
  const handleSetMsg = useCallback((msg: IChatMessage) => {
    setMsgToReply(msg)
  }, [])

  const isSurveyOpened =
    Boolean(status) && status !== surveyStatus.CLOSED && (isFilledUser || isSponsor)

  return (
    <div className={styles.chatBlock}>
      <div className={styles.chatHeader}>
        <p>ЧАТ</p>
        <ButtonFAQ />
      </div>

      <div className={styles.chat}>
        <ChatScroll
          isReminderAvailable={isReminderAvailable}
          handleSetMsg={handleSetMsg}
          isSurveyOpened={isSurveyOpened}
        />
      </div>

      <ChatBottom msgReplyTo={msgToReply} handleCancelReply={handleCancelReply} />
    </div>
  )
}

export default WebinarChatNew
